/**
 * @file_purpose  page for showing candidate details
 * @author Sucheta Singha
 * @Date_Created 27-02-2025
 * @Date_Modified 27-02-2025
 */
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
    CButton,
    CCol,
    CDataTable,
    CRow,
    CLabel,
    CSelect,
    CInput,
    CModalBody,
    CCard, CForm, CSpinner
} from '@coreui/react'
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory } from 'react-router-dom'
import helpers from 'src/Utility/Helpers';
import Constants from 'src/Utility/Constants';
import { Modal } from 'react-bootstrap';
import OnBoardingService from "src/apis/OnBoardingService";
import RouteURL from "src/apis/ApiURL";
import masterData from 'src/Utility/MasterData';
import logout from "../../../assets/icons/logout.png";
import logo from "../../../assets/icons/visitor_logo.png"



const OnBoardCandidateDetails = (props) => {

    var accessToken = localStorage.getItem("candidate_onboard_auth_token");
    const history = useHistory();

    //Define states
    const [loadingData, setLoadingData] = useState(true);
    const [loader, setLoader] = useState(0);
    var [date, setDate] = useState(new Date());
    const [mode, setMode] = useState("show");
    const [isActive, setIsActive] = useState(false)
    const [candidateDetails, setCandidateDetails] = useState({});
    const [state, setState] = useState({
        name: '',
        email: '',
        mobile: '',
        mode: true,
        is_correct: ''
    })
    const [errorSatate, setErrorState] = useState({
        name: '',
        email: '',
        mobile: '',
    })
    useEffect(() => {
        if (localStorage.getItem("candidate_onboard_verified") === "yes") {
            history.push(`/onboarding-form`);
            window.location.reload();
        }

        if (!accessToken) {
            localStorage.removeItem('candidate_onboard_auth_token');
            history.push(`/onboarding-candidate/${localStorage.getItem("candidate_onboard_token")}`);
            window.location.reload();
        }

        /**
     * @author Sucheta Singha
     * @Date_Created 27-02-2025
     * @Date_Modified 27-02-2025
     * @function async
     * @functionName loadCandidateDetails
     * @functionPurpose this function gets candidate details.
     *
     * @functionParam {}
     *
     * @functionSuccess Success status and message.
     *
     * @functionError {Boolean} error is there.
     * @functionError {String} message  Description message.
     */

        async function loadCandidateDetails() {
            OnBoardingService.apiGetCallRequest(RouteURL.getOnBoardingCandidateOTPVerificationDetails)
                .then((res) => {
                    if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                        const data = res.data[0];
                        setCandidateDetails(data)
                        setState(prevState => ({
                            ...prevState,
                            name: helpers.checkNull(data.initial_name),
                            email: helpers.checkNull(data.initial_email),
                            mobile: helpers.checkNull(data.phone)
                        }))
                        setLoadingData(false);
                    } else {
                        toast.error(res.message, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error)
                });
        }

        if (loadingData) {
            // if the result is not ready so you make the axios call
            loadCandidateDetails()
        }

    }, [loadingData]);


    const handleChange = (e) => {
        var newValue
        if (e.target.type == "checkbox") {
            const { id, checked } = e.target
            newValue = checked ? 1 : 0
            setState(prevState => ({
                ...prevState,
                [id]: newValue
            }))
        }
        else {
            const { id, value } = e.target
            newValue = value
            setState(prevState => ({
                ...prevState,
                [id]: newValue
            }))
        }
    }
    const handleChangeCorrection = (e) => {
        var newValue
        const { id, value } = e.target
        newValue = value
        setState(prevState => ({
            ...prevState,
            [id]: newValue
        }))

        if (newValue === "yes") {
            setMode("next")
        } else {
            setMode("edit")
        }
    }



    /* Validation Checking */
    const ValidateForm = (e) => {
        e.preventDefault();
        if (handleValidation()) {
            UpdateCandidateDetails();
        }
        else {
            toast.error("Please fill all * fields !", {
                position: toast.POSITION.BOTTOM_RIGHT,
                toastId: 'success1',
            });
        }
    }

    /* Validate all fields */
    const handleValidation = (e) => {
        let formIsValid = true;

        //  name
        if (!state.name) {
            formIsValid = false;
            setErrorState((prevState) => ({
                ...prevState,
                name: 'Name can not be empty',
            }));
        } else {
            setErrorState((prevState) => ({
                ...prevState,
                name: '',
            }));
        }

        // email
        if (!state.email) {
            formIsValid = false;
            setErrorState((prevState) => ({
                ...prevState,
                email: 'Email can not be empty',
            }));
        } else if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(state.email))) {
            formIsValid = false;
            setErrorState((prevState) => ({
                ...prevState,
                email: 'Email is not valid',
            }));
        } else {
            setErrorState((prevState) => ({
                ...prevState,
                email: '',
            }));
        }

        // mobile
        if (!state.mobile) {
            formIsValid = false;
            setErrorState((prevState) => ({
                ...prevState,
                email: 'Mobile number can not be empty',
            }));
        }
        else if (!(state.mobile.length >= 10 && state.mobile.length <= 15)) {
            formIsValid = false;
            setErrorState((prevState) => ({
                ...prevState,
                mobile: 'Should be limited to 10-15 integers.',
            }));
        }
        else {
            setErrorState((prevState) => ({
                ...prevState,
                mobile: '',
            }));
        }


        return formIsValid;
    }



    /**
    * @author Sucheta Singha
    * @Date_Created 03-03-2025
    * @Date_Modified 03-03-2025
    * @function sync
    * @functionName UpdateCandidateDetails
    * @functionPurpose this function add and edit applicant/candidate details.
    *
    * @functionParam {payload object:name,email,mobile}
    * 
    * @functionSuccess Success status and message.
    *
    * @functionError {Boolean} error is there.
    * @functionError {String} message  Description message.
    */
    const UpdateCandidateDetails = (e) => {
        setIsActive(true);

        const formData = new FormData();
        formData.append("name", state.name);
        formData.append("email", state.email);
        formData.append("phone", state.mobile);

        let params = formData
        OnBoardingService.apiPostCallFormDataRequest(RouteURL.updateOnBoardingCandidateDetails, params)
            .then((res) => {
                if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                    setIsActive(false);
                    localStorage.setItem("candidate_onboard_verified", "yes");
                    history.push(`/onboarding-form`);
                    toast.success(res.message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
                else {
                    setIsActive(false)
                    toast.error(res.message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            }).catch(error => {
                console.log(error);
            })

    }
    /* Validation Checking */
    const GoToNext = (e) => {
        history.push(`/onboarding-form`);
    }

    const logoutSubmitClick = (e) => {
        window.location.reload();
        history.push(`/onboarding-candidate/${localStorage.getItem("candidate_onboard_token")}`);
        localStorage.removeItem("candidate_onboard_auth_token");

    }



    return (
        <>
            <ToastContainer />
            <header className="header_sec">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3">
                            <div className="visitor_hed">
                                <img src={logo} alt='' />
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-5 col-md-4 col-sm-12 d-none d-md-block"></div>
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-5 col-sm-9 col-9">
                            <div className="visitor_hed_rt">
                                <span className="visit_date">{moment(new Date().toJSON().slice(0, 10)).format("DD-MM-YYYY")} | <span className="visit_time">
                                    {date.toLocaleTimeString()}
                                </span></span>

                                <span className="visiter_logout_sec" onClick={(e) => logoutSubmitClick(e)}>
                                    <img src={logout} alt='' />
                                    <span className="logout_mob">Logout</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <CRow>
                <CCol style={{ margin: "20px" }}>

                    <div className="main_visitor">
                        <div className="row">
                            <div className="col-xxl-3 col-sm-6 col-xl-3 col-lg-4 col-md-4 col-sm-8 col-9">
                                <h6 className="visit_txt_hed">
                                    {/* Candidate On Boarding Process - <span>{moment(new Date().toJSON().slice(0, 10)).format("DD-MM-YYYY")}</span> */}
                                </h6>
                            </div>
                            <div className="col-xxl-7 col-xl-6 col-lg-6 col-md-5 col-sm-1 d-none d-md-block">
                                <div className="month_sec">

                                </div>
                            </div>
                            <div className="col-xxl-2 col-xl-3 col-lg-2 col-md-3 col-sm-4 col-3 visitor_add">
                            </div>

                        </div>

                        <CRow>

                        </CRow>

                        <CCard>
                            <div className="apply_comp_sec">
                                <h6 className="hed_txt">Your Details</h6>
                                <div className="comp_inner_sec">
                                    <CForm action="" method="post" encType="multipart/form-data" className="form-horizontal">
                                        {isActive ? (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    position: "absolute",
                                                    width: "100%",
                                                    marginTop: 150,
                                                }}
                                            >
                                                {" "}
                                                <CSpinner
                                                    style={{ width: "4rem", height: "4rem" }}
                                                    color="danger"
                                                    variant="grow"
                                                    className="loader_z_index"
                                                />
                                                <div className="modal-backdrop fade show"></div>
                                            </div>

                                        ) : (
                                            ""
                                        )}

                                        <div className="row">
                                            <div className="col-xxl-6 col-xl-6 col-lg-4 col-md-6 col-sm-12">
                                                <div className="comp_off_inn">
                                                    <CLabel htmlFor="text-input">Name <span style={{ color: "red" }}>*</span></CLabel>
                                                    <CInput name="name" id="name" placeholder="Your name" value={state.name} onChange={handleChange} disabled={mode !== "edit" ? true : ""} />
                                                    <span style={{ color: "red" }}> {errorSatate.name}</span>
                                                </div>
                                            </div>

                                            <div className="col-xxl-6 col-xl-6 col-lg-4 col-md-6 col-sm-12">
                                                <div className="comp_off_inn">
                                                    <CLabel htmlFor="text-input"> Email <span style={{ color: "red" }}>*</span></CLabel>
                                                    <CInput name="email" id="email" placeholder="Your email" value={state.email} onChange={handleChange} disabled={mode !== "edit" ? true : ""} />
                                                    <span style={{ color: "red" }}> {errorSatate.email}</span>
                                                </div>
                                            </div>

                                            <div className="col-xxl-6 col-xl-6 col-lg-4 col-md-6 col-sm-12">
                                                <div className="comp_off_inn">
                                                    <CLabel htmlFor="text-input">Mobile <span style={{ color: "red" }}>*</span></CLabel>
                                                    <CInput name="mobile" id="mobile" placeholder="Your mobile" value={state.mobile} onChange={handleChange} disabled={mode !== "edit" ? true : ""} />
                                                    <span style={{ color: "red" }}> {errorSatate.mobile}</span>
                                                </div>
                                            </div>

                                            <div className="col-xxl-6 col-xl-6 col-lg-4 col-md-6 col-sm-12">
                                                <div className="comp_off_inn">
                                                    <CRow>
                                                        <div className="col-md-6">
                                                            <div className='con2 terms_sec_cal' style={{ display: "flex", alignItems: "center", justifyContent: "start", height: "35px", lineHeight: "35px" }}>
                                                                <label class={"con1 label_drk"}>
                                                                    <input width="10px" type='radio' id="is_correct" name="is_correct" value="yes" onChange={handleChangeCorrection} />
                                                                    <span class="checkmark"></span>
                                                                </label>

                                                                <span> &nbsp; Yes, Correct</span>
                                                            </div>
                                                            {/* </div>
                                                    <div className="col-md-6"> */}
                                                            <div className='con2 terms_sec_cal' style={{ display: "flex", alignItems: "center", justifyContent: "start", height: "35px", lineHeight: "35px" }}>
                                                                <label class={"con1 label_drk"}>
                                                                    <input width="10px" type='radio' id="is_correct" name="is_correct" value="no" onChange={handleChangeCorrection} />
                                                                    <span class="checkmark"></span>
                                                                </label>

                                                                <span> &nbsp; No, Correction Required</span>
                                                            </div>
                                                        </div>
                                                    </CRow>
                                                </div>
                                            </div>


                                        </div>



                                        {mode == "edit" ?
                                            <div className="comp_off_inn">
                                                <CRow>
                                                    <CCol xs="12" className="atten_sec1" style={{ textAlign: 'center' }}>
                                                        <CButton size="lg" className="save"
                                                            onClick={ValidateForm}
                                                            style={{ margin: "4px" }}>Submit</CButton>

                                                    </CCol>
                                                </CRow>
                                            </div>
                                            :
                                            (mode == "next" ? <div className="comp_off_inn">
                                                <CRow>
                                                    <CCol xs="12" className="atten_sec1" style={{ textAlign: 'center' }}>
                                                        <CButton size="lg" className="save"
                                                            onClick={GoToNext}
                                                            style={{ margin: "4px" }}>Next</CButton>

                                                    </CCol>
                                                </CRow>
                                            </div>
                                                : "")
                                        }

                                    </CForm>
                                </div>
                            </div>
                        </CCard>
                    </div>


                </CCol>



            </CRow>
        </>
    )
}
export default OnBoardCandidateDetails
